import React, { useEffect, useState } from "react";
import styles from "./index.module.css";
import Button from "../../../Components/Button";
import { IoClose } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";
import { getCancellationNotes, updateClubbedTripStatus } from "../action";
import Loader from "../../../Components/Loader";
import { useTranslation } from "react-i18next";
import { TRIP_STATUS } from "../../../helpers/constants";
import SwipeButton from "../../../Components/SwipeButton";

const CancelTrip = ({ onClose, type, tripId }) => {
  const {
    cancellation_notes: cancellationNotes = [],
    entity_type: entityTpe = "",
  } = useSelector((state) => state.transport.cancellationReasons);

  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [loader, toggleLoader] = useState(false);
  const [onCancel, toggleCancel] = useState(false);
  const [note, setNote] = useState("");

  useEffect(() => {
    toggleLoader(true);
    dispatch(getCancellationNotes(type, () => toggleLoader(false)));
  }, []);

  const cancelTrip = () => {
    toggleCancel(true);
    const body = {
      destination_id: "",
      notes: note,
    };
    dispatch(
      updateClubbedTripStatus(tripId, TRIP_STATUS.CANCELED, body, () =>
        toggleCancel(false)
      )
    );
  };

  return (
    <div className={styles["cancel_trip"]}>
      <span className={styles["cancel_trip-close"]}>
        <Button
          type={"button"}
          transparentGreyButton
          roundedButton
          fitChild
          onClick={onClose}
        >
          <IoClose size={32} color={"#3D5973"} />
        </Button>
      </span>
      <label className={styles["cancel_trip-label"]}>
        {t("Why do you want to cancel this trip?")}
      </label>
      {loader ? (
        <Loader spinner />
      ) : (
        <section className={styles["cancel_trip--reasons"]}>
          {cancellationNotes?.map((item, key) => (
            <Button
              key={key}
              lightButton={item?.note === note ? false : true}
              smallFont
              shadow
              maxRadius
              onClick={() => setNote(item?.note)}
            >
              {item?.note}
            </Button>
          ))}
        </section>
      )}
      <SwipeButton
        onComplete={cancelTrip}
        label={t("Cancel")}
        loader={onCancel}
        disabled={!note}
      />
    </div>
  );
};

export default CancelTrip;
